export type Currency = {
  id: number
  name: string
  unit: string
  position: string
}

export const currencies: Currency[] = [
  { id: 1, name: 'USD', unit: '$', position: 'left' },
  { id: 2, name: 'JPY', unit: '¥', position: 'left' },
  { id: 3, name: 'RUB', unit: '₽', position: 'left' },
  { id: 4, name: 'AED(UAE)', unit: 'AED', position: 'right' },
  { id: 5, name: 'INR', unit: '₹', position: 'left' },
]
